import { B as $, D as ee, E as te, I as ne, N as re, O as ae, P as oe, Z as _, a as ie, b as se, c as ue, d as ce, e as de, f as le, g as me, h as fe, i as he, j as F, k as ge, l as pe, m as ye, n as be, p as we, q as ve, r as Me, t as xe, u as Se, v as Pe, w as Oe, x as je, y as Te, z as Ae, A as Ee, C as De, F as ke, G as _e, H as Ne, J as We, K as Ze, L as Ce, M as Fe, Q as Le, R as qe, S as Ie, T as Je, U as Ye, V as He, W as Qe, X as Ge, Y as Be, _ as Ue, $ as Xe, a0 as ze, a1 as Re, a2 as Ve, a3 as Ke, a4 as $e, a5 as et, a6 as tt, a7 as L, a8 as nt, a9 as rt, aa as at, ab as ot, ac as it, ad as st, ae as ut, af as ct, ag as dt, ah as lt, ai as mt, aj as ft, ak as ht, al as gt, am as pt, an as yt, ao as bt, ap as wt, aq as vt, ar as Mt, as as xt, o as St, at as Pt, au as Ot, av as jt, aw as Tt, ax as At, ay as Et, az as Dt, aA as kt, aB as _t, aC as Nt, aD as Wt, aE as Zt, aF as Ct, s as Ft, aG as Lt, aH as qt, aI as It, aJ as Jt, aK as Yt, aL as Ht, aM as Qt } from "./types-d722vHv3.js";
import { g as U } from "./get-BqrHaTdZ.js";
import { t as D, a as Gt, e as C, f as N, h as O, i as j, j as Bt } from "./en-US-DzLLmR2o.js";
import { d as Ut } from "./differenceInCalendarDays-BtfJmFUw.js";
import { c as Xt, g as zt, a as Rt, b as Vt, d as Kt, l as $t, i as en, e as tn, w as nn } from "./protectedTokens-CpdGM6ML.js";
import { a as l } from "./addLeadingZeros-DEhn_sgb.js";
function rn(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function an(e) {
  if (!rn(e) && typeof e != "number")
    return !1;
  const r = D(e);
  return !isNaN(Number(r));
}
function on(e) {
  const r = D(e), n = Xt(e, 0);
  return n.setFullYear(r.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function sn(e) {
  const r = D(e);
  return Ut(r, on(r)) + 1;
}
const w = {
  // Year
  y(e, r) {
    const n = e.getFullYear(), t = n > 0 ? n : 1 - n;
    return l(r === "yy" ? t % 100 : t, r.length);
  },
  // Month
  M(e, r) {
    const n = e.getMonth();
    return r === "M" ? String(n + 1) : l(n + 1, 2);
  },
  // Day of the month
  d(e, r) {
    return l(e.getDate(), r.length);
  },
  // AM or PM
  a(e, r) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, r) {
    return l(e.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(e, r) {
    return l(e.getHours(), r.length);
  },
  // Minute
  m(e, r) {
    return l(e.getMinutes(), r.length);
  },
  // Second
  s(e, r) {
    return l(e.getSeconds(), r.length);
  },
  // Fraction of second
  S(e, r) {
    const n = r.length, t = e.getMilliseconds(), s = Math.trunc(
      t * Math.pow(10, n - 3)
    );
    return l(s, r.length);
  }
}, P = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, q = {
  // Era
  G: function(e, r, n) {
    const t = e.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(t, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(t, { width: "wide" });
    }
  },
  // Year
  y: function(e, r, n) {
    if (r === "yo") {
      const t = e.getFullYear(), s = t > 0 ? t : 1 - t;
      return n.ordinalNumber(s, { unit: "year" });
    }
    return w.y(e, r);
  },
  // Local week-numbering year
  Y: function(e, r, n, t) {
    const s = Kt(e, t), o = s > 0 ? s : 1 - s;
    if (r === "YY") {
      const i = o % 100;
      return l(i, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : l(o, r.length);
  },
  // ISO week-numbering year
  R: function(e, r) {
    const n = Vt(e);
    return l(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, r) {
    const n = e.getFullYear();
    return l(n, r.length);
  },
  // Quarter
  Q: function(e, r, n) {
    const t = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
        return String(t);
      // 01, 02, 03, 04
      case "QQ":
        return l(t, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, r, n) {
    const t = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "q":
        return String(t);
      // 01, 02, 03, 04
      case "qq":
        return l(t, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(t, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, r, n) {
    const t = e.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return w.M(e, r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(t + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(t, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(t, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, r, n) {
    const t = e.getMonth();
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return String(t + 1);
      // 01, 02, ..., 12
      case "LL":
        return l(t + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(t + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(t, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(t, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, r, n, t) {
    const s = Rt(e, t);
    return r === "wo" ? n.ordinalNumber(s, { unit: "week" }) : l(s, r.length);
  },
  // ISO week of year
  I: function(e, r, n) {
    const t = zt(e);
    return r === "Io" ? n.ordinalNumber(t, { unit: "week" }) : l(t, r.length);
  },
  // Day of the month
  d: function(e, r, n) {
    return r === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : w.d(e, r);
  },
  // Day of year
  D: function(e, r, n) {
    const t = sn(e);
    return r === "Do" ? n.ordinalNumber(t, { unit: "dayOfYear" }) : l(t, r.length);
  },
  // Day of week
  E: function(e, r, n) {
    const t = e.getDay();
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(t, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(t, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, r, n, t) {
    const s = e.getDay(), o = (s - t.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return l(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, r, n, t) {
    const s = e.getDay(), o = (s - t.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return l(o, r.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, r, n) {
    const t = e.getDay(), s = t === 0 ? 7 : t;
    switch (r) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return l(s, r.length);
      // 2nd
      case "io":
        return n.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return n.day(t, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(t, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, r, n) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, r, n) {
    const t = e.getHours();
    let s;
    switch (t === 12 ? s = P.noon : t === 0 ? s = P.midnight : s = t / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, r, n) {
    const t = e.getHours();
    let s;
    switch (t >= 17 ? s = P.evening : t >= 12 ? s = P.afternoon : t >= 4 ? s = P.morning : s = P.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, r, n) {
    if (r === "ho") {
      let t = e.getHours() % 12;
      return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
    }
    return w.h(e, r);
  },
  // Hour [0-23]
  H: function(e, r, n) {
    return r === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : w.H(e, r);
  },
  // Hour [0-11]
  K: function(e, r, n) {
    const t = e.getHours() % 12;
    return r === "Ko" ? n.ordinalNumber(t, { unit: "hour" }) : l(t, r.length);
  },
  // Hour [1-24]
  k: function(e, r, n) {
    let t = e.getHours();
    return t === 0 && (t = 24), r === "ko" ? n.ordinalNumber(t, { unit: "hour" }) : l(t, r.length);
  },
  // Minute
  m: function(e, r, n) {
    return r === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : w.m(e, r);
  },
  // Second
  s: function(e, r, n) {
    return r === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : w.s(e, r);
  },
  // Fraction of second
  S: function(e, r) {
    return w.S(e, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, r, n) {
    const t = e.getTimezoneOffset();
    if (t === 0)
      return "Z";
    switch (r) {
      // Hours and optional minutes
      case "X":
        return J(t);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return x(t);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return x(t, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, r, n) {
    const t = e.getTimezoneOffset();
    switch (r) {
      // Hours and optional minutes
      case "x":
        return J(t);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return x(t);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return x(t, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, r, n) {
    const t = e.getTimezoneOffset();
    switch (r) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + I(t, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + x(t, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, r, n) {
    const t = e.getTimezoneOffset();
    switch (r) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + I(t, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + x(t, ":");
    }
  },
  // Seconds timestamp
  t: function(e, r, n) {
    const t = Math.trunc(e.getTime() / 1e3);
    return l(t, r.length);
  },
  // Milliseconds timestamp
  T: function(e, r, n) {
    const t = e.getTime();
    return l(t, r.length);
  }
};
function I(e, r = "") {
  const n = e > 0 ? "-" : "+", t = Math.abs(e), s = Math.trunc(t / 60), o = t % 60;
  return o === 0 ? n + String(s) : n + String(s) + r + l(o, 2);
}
function J(e, r) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + l(Math.abs(e) / 60, 2) : x(e, r);
}
function x(e, r = "") {
  const n = e > 0 ? "-" : "+", t = Math.abs(e), s = l(Math.trunc(t / 60), 2), o = l(t % 60, 2);
  return n + s + r + o;
}
const un = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, cn = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, dn = /^'([^]*?)'?$/, ln = /''/g, mn = /[a-zA-Z]/;
function fn(e, r, n) {
  var h, g, m, S, v, M, b, T;
  const t = Gt(), s = (n == null ? void 0 : n.locale) ?? t.locale ?? C, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((g = (h = n == null ? void 0 : n.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((S = (m = t.locale) == null ? void 0 : m.options) == null ? void 0 : S.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((M = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : M.weekStartsOn) ?? t.weekStartsOn ?? ((T = (b = t.locale) == null ? void 0 : b.options) == null ? void 0 : T.weekStartsOn) ?? 0, c = D(e);
  if (!an(c))
    throw new RangeError("Invalid time value");
  let u = r.match(cn).map((y) => {
    const p = y[0];
    if (p === "p" || p === "P") {
      const k = $t[p];
      return k(y, s.formatLong);
    }
    return y;
  }).join("").match(un).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const p = y[0];
    if (p === "'")
      return { isToken: !1, value: hn(y) };
    if (q[p])
      return { isToken: !0, value: y };
    if (p.match(mn))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: y };
  });
  s.localize.preprocessor && (u = s.localize.preprocessor(c, u));
  const d = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: s
  };
  return u.map((y) => {
    if (!y.isToken) return y.value;
    const p = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && en(p) || !(n != null && n.useAdditionalDayOfYearTokens) && tn(p)) && nn(p, r, String(e));
    const k = q[p[0]];
    return k(c, p, s.localize, d);
  }).join("");
}
function hn(e) {
  const r = e.match(dn);
  return r ? r[1].replace(ln, "'") : e;
}
const a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BRAND: $,
  DIRTY: ee,
  EMPTY_PATH: te,
  INVALID: ne,
  NEVER: re,
  OK: ae,
  ParseStatus: oe,
  Schema: _,
  ZodAny: ie,
  ZodArray: se,
  ZodBigInt: ue,
  ZodBoolean: ce,
  ZodBranded: de,
  ZodCatch: le,
  ZodDate: me,
  ZodDefault: fe,
  ZodDiscriminatedUnion: he,
  ZodEffects: F,
  ZodEnum: ge,
  ZodError: pe,
  get ZodFirstPartyTypeKind() {
    return ye;
  },
  ZodFunction: be,
  ZodIntersection: we,
  ZodIssueCode: ve,
  ZodLazy: Me,
  ZodLiteral: xe,
  ZodMap: Se,
  ZodNaN: Pe,
  ZodNativeEnum: Oe,
  ZodNever: je,
  ZodNull: Te,
  ZodNullable: Ae,
  ZodNumber: Ee,
  ZodObject: De,
  ZodOptional: ke,
  ZodParsedType: _e,
  ZodPipeline: Ne,
  ZodPromise: We,
  ZodReadonly: Ze,
  ZodRecord: Ce,
  ZodSchema: _,
  ZodSet: Fe,
  ZodString: Le,
  ZodSymbol: qe,
  ZodTransformer: F,
  ZodTuple: Ie,
  ZodType: _,
  ZodUndefined: Je,
  ZodUnion: Ye,
  ZodUnknown: He,
  ZodVoid: Qe,
  addIssueToContext: Ge,
  any: Be,
  array: Ue,
  bigint: Xe,
  boolean: ze,
  coerce: Re,
  custom: Ve,
  date: Ke,
  datetimeRegex: $e,
  defaultErrorMap: et,
  discriminatedUnion: tt,
  effect: L,
  enum: nt,
  function: rt,
  getErrorMap: at,
  getParsedType: ot,
  instanceof: it,
  intersection: st,
  isAborted: ut,
  isAsync: ct,
  isDirty: dt,
  isValid: lt,
  late: mt,
  lazy: ft,
  literal: ht,
  makeIssue: gt,
  map: pt,
  nan: yt,
  nativeEnum: bt,
  never: wt,
  null: vt,
  nullable: Mt,
  number: xt,
  object: St,
  get objectUtil() {
    return Pt;
  },
  oboolean: Ot,
  onumber: jt,
  optional: Tt,
  ostring: At,
  pipeline: Et,
  preprocess: Dt,
  promise: kt,
  quotelessJson: _t,
  record: Nt,
  set: Wt,
  setErrorMap: Zt,
  strictObject: Ct,
  string: Ft,
  symbol: Lt,
  transformer: L,
  tuple: qt,
  undefined: It,
  union: Jt,
  unknown: Yt,
  get util() {
    return Ht;
  },
  void: Qt
}, Symbol.toStringTag, { value: "Module" })), gn = a.object({
  role: a.literal("system"),
  content: a.string(),
  providerOptions: a.record(a.string(), a.any()).optional()
}), pn = a.object({
  type: a.literal("text"),
  text: a.string(),
  providerOptions: a.record(a.string(), a.any()).optional()
}), yn = a.object({
  type: a.literal("image"),
  imageUrl: a.string(),
  mimeType: a.string().optional(),
  providerOptions: a.record(a.string(), a.any()).optional()
}), bn = a.object({
  type: a.literal("file"),
  fileUrl: a.string(),
  filename: a.string().optional(),
  mimeType: a.string(),
  providerOptions: a.record(a.string(), a.any()).optional()
}), wn = a.union([
  pn,
  yn,
  bn
]), vn = a.object({
  role: a.literal("user"),
  content: a.union([a.string(), a.array(wn)]),
  providerOptions: a.record(a.string(), a.any()).optional()
}), Y = a.union([gn, vn]), Mn = a.discriminatedUnion("type", [
  a.object({
    description: a.string().optional(),
    parameters: a.any(),
    type: a.literal("function")
  }),
  a.object({
    type: a.literal("provider-defined"),
    parameters: a.any(),
    id: a.string().regex(/^[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+$/),
    args: a.record(a.string(), a.unknown())
  })
]), xn = a.object({
  model: a.enum([
    "o3",
    "o4-mini",
    "gpt-4.1",
    "gpt-4.1-mini",
    "gpt-4.1-nano",
    "gpt-4o",
    "gpt-4o-mini"
  ])
}), Sn = a.object({
  model: a.enum([
    "claude-opus-4-0",
    "claude-sonnet-4-0",
    "claude-3-7-sonnet-latest",
    "claude-3-5-haiku-latest"
  ])
}), Pn = a.object({
  model: a.enum([
    "ministral-3b-latest",
    "ministral-8b-latest",
    "mistral-large-latest",
    "mistral-small-latest",
    "pixtral-large-latest",
    "pixtral-12b-latest"
  ])
}), On = a.object({
  model: a.enum([
    "command-a-03-2025",
    "command-r7b-12-2024",
    "command-r-plus",
    "command-r",
    "command"
  ])
}), jn = a.object({
  model: a.enum([
    "gemini-2.0-flash",
    "gemini-2.0-flash-lite",
    "gemini-2.5-flash-preview-05-20",
    "gemini-2.5-pro-preview-05-06"
  ])
}), Tn = a.object({
  model: a.enum(["text-embedding-3-small", "text-embedding-3-large"])
}), An = a.object({
  model: a.never()
}), En = a.object({
  model: a.enum(["mistral-embed"])
}), Dn = a.object({
  model: a.enum([
    "embed-english-v3.0",
    "embed-multilingual-v3.0",
    "embed-english-light-v3.0",
    "embed-multilingual-light-v3.0"
  ])
}), kn = a.object({
  model: a.enum(["text-embedding-004"])
}), X = a.object({
  provider: a.literal("openai")
}), z = a.object({
  provider: a.literal("anthropic")
}), R = a.object({
  provider: a.literal("mistral")
}), V = a.object({
  provider: a.literal("cohere")
}), K = a.object({
  provider: a.literal("google")
}), A = a.object({
  apiKey: a.string(),
  temperature: a.number().optional()
}), _n = a.object({
  operation: a.literal("generateText")
}), Nn = a.object({
  operation: a.literal("generateObject")
}), Wn = a.object({
  operation: a.literal("streamText")
}), Zn = a.object({
  operation: a.literal("embed")
}), W = a.object({
  model: a.discriminatedUnion("provider", [
    X.merge(xn),
    z.merge(Sn),
    R.merge(Pn),
    V.merge(On),
    K.merge(jn)
  ])
}), Cn = a.object({
  model: a.discriminatedUnion("provider", [
    X.merge(Tn),
    z.merge(An),
    R.merge(En),
    V.merge(Dn),
    K.merge(kn)
  ])
}), Mr = a.discriminatedUnion("operation", [
  Nn.merge(A).merge(W).extend({
    prompt: a.string(),
    schema: a.any().describe("jsOnly")
  }),
  _n.merge(A).merge(W).extend({
    messages: a.array(Y).optional().describe("jsOnly"),
    system: a.string().optional(),
    prompt: a.string().optional(),
    tools: a.record(a.string(), Mn).describe("jsOnly"),
    toolChoice: a.enum(["auto", "required", "none"]).optional()
  }),
  Wn.merge(A).merge(W).extend({
    messages: a.array(Y).optional().describe("jsOnly"),
    system: a.string().optional(),
    prompt: a.string().optional()
  }),
  Zn.merge(A).merge(Cn).extend({
    value: a.string()
  })
]);
a.discriminatedUnion("type", [
  a.object({
    type: a.literal("result"),
    value: a.object({
      reasoning: a.string().optional(),
      text: a.string(),
      toolCalls: a.array(a.object({
        type: a.enum(["function", "tool-call"]),
        toolName: a.string(),
        toolCallId: a.string(),
        id: a.string().optional(),
        args: a.any()
      }))
    })
  }),
  a.object({
    type: a.literal("objectResult"),
    value: a.any()
  }),
  a.object({
    type: a.literal("streamChunk"),
    value: a.string()
  }),
  a.object({
    type: a.literal("streamResult"),
    value: a.object({
      text: a.string()
    })
  }),
  a.object({
    type: a.literal("embeddingResult"),
    value: a.array(a.number())
  }),
  a.object({
    type: a.literal("error"),
    error: a.string()
  })
]);
const H = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Fn = (e, r, n) => {
  let t;
  const s = n != null && n.addSuffix ? H[e].withPreposition : H[e].standalone;
  return typeof s == "string" ? t = s : r === 1 ? t = s.one : t = s.other.replace("{{count}}", String(r)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + t : "vor " + t : t;
}, Ln = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, qn = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, In = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Jn = {
  date: N({
    formats: Ln,
    defaultWidth: "full"
  }),
  time: N({
    formats: qn,
    defaultWidth: "full"
  }),
  dateTime: N({
    formats: In,
    defaultWidth: "full"
  })
}, Yn = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, Hn = (e, r, n, t) => Yn[e], Qn = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, Gn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, Z = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, Bn = {
  narrow: Z.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: Z.wide
}, Un = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, Xn = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, zn = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, Rn = (e) => Number(e) + ".", Vn = {
  ordinalNumber: Rn,
  era: O({
    values: Qn,
    defaultWidth: "wide"
  }),
  quarter: O({
    values: Gn,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: O({
    values: Z,
    formattingValues: Bn,
    defaultWidth: "wide"
  }),
  day: O({
    values: Un,
    defaultWidth: "wide"
  }),
  dayPeriod: O({
    values: Xn,
    defaultWidth: "wide",
    formattingValues: zn,
    defaultFormattingWidth: "wide"
  })
}, Kn = /^(\d+)(\.)?/i, $n = /\d+/i, er = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, tr = {
  any: [/^v/i, /^n/i]
}, nr = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, rr = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ar = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, or = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ir = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, sr = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, ur = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, cr = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, dr = {
  ordinalNumber: Bt({
    matchPattern: Kn,
    parsePattern: $n,
    valueCallback: (e) => parseInt(e)
  }),
  era: j({
    matchPatterns: er,
    defaultMatchWidth: "wide",
    parsePatterns: tr,
    defaultParseWidth: "any"
  }),
  quarter: j({
    matchPatterns: nr,
    defaultMatchWidth: "wide",
    parsePatterns: rr,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: j({
    matchPatterns: ar,
    defaultMatchWidth: "wide",
    parsePatterns: or,
    defaultParseWidth: "any"
  }),
  day: j({
    matchPatterns: ir,
    defaultMatchWidth: "wide",
    parsePatterns: sr,
    defaultParseWidth: "any"
  }),
  dayPeriod: j({
    matchPatterns: ur,
    defaultMatchWidth: "wide",
    parsePatterns: cr,
    defaultParseWidth: "any"
  })
}, lr = {
  code: "de",
  formatDistance: Fn,
  formatLong: Jn,
  formatRelative: Hn,
  localize: Vn,
  match: dr,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var E = { exports: {} }, mr = E.exports, Q;
function fr() {
  return Q || (Q = 1, function(e, r) {
    (function(n, t) {
      e.exports = t();
    })(mr, function() {
      Array.isArray || (Array.isArray = function(o) {
        return Object.prototype.toString.call(o) === "[object Array]";
      });
      function n(o) {
        for (var i = [], c = 0, u = o.length; c < u; c++)
          i.indexOf(o[c]) === -1 && i.push(o[c]);
        return i;
      }
      var t = {}, s = {
        "==": function(o, i) {
          return o == i;
        },
        "===": function(o, i) {
          return o === i;
        },
        "!=": function(o, i) {
          return o != i;
        },
        "!==": function(o, i) {
          return o !== i;
        },
        ">": function(o, i) {
          return o > i;
        },
        ">=": function(o, i) {
          return o >= i;
        },
        "<": function(o, i, c) {
          return c === void 0 ? o < i : o < i && i < c;
        },
        "<=": function(o, i, c) {
          return c === void 0 ? o <= i : o <= i && i <= c;
        },
        "!!": function(o) {
          return t.truthy(o);
        },
        "!": function(o) {
          return !t.truthy(o);
        },
        "%": function(o, i) {
          return o % i;
        },
        log: function(o) {
          return console.log(o), o;
        },
        in: function(o, i) {
          return !i || typeof i.indexOf > "u" ? !1 : i.indexOf(o) !== -1;
        },
        cat: function() {
          return Array.prototype.join.call(arguments, "");
        },
        substr: function(o, i, c) {
          if (c < 0) {
            var u = String(o).substr(i);
            return u.substr(0, u.length + c);
          }
          return String(o).substr(i, c);
        },
        "+": function() {
          return Array.prototype.reduce.call(arguments, function(o, i) {
            return parseFloat(o, 10) + parseFloat(i, 10);
          }, 0);
        },
        "*": function() {
          return Array.prototype.reduce.call(arguments, function(o, i) {
            return parseFloat(o, 10) * parseFloat(i, 10);
          });
        },
        "-": function(o, i) {
          return i === void 0 ? -o : o - i;
        },
        "/": function(o, i) {
          return o / i;
        },
        min: function() {
          return Math.min.apply(this, arguments);
        },
        max: function() {
          return Math.max.apply(this, arguments);
        },
        merge: function() {
          return Array.prototype.reduce.call(arguments, function(o, i) {
            return o.concat(i);
          }, []);
        },
        var: function(o, i) {
          var c = i === void 0 ? null : i, u = this;
          if (typeof o > "u" || o === "" || o === null)
            return u;
          for (var d = String(o).split("."), h = 0; h < d.length; h++)
            if (u == null || (u = u[d[h]], u === void 0))
              return c;
          return u;
        },
        missing: function() {
          for (var o = [], i = Array.isArray(arguments[0]) ? arguments[0] : arguments, c = 0; c < i.length; c++) {
            var u = i[c], d = t.apply({ var: u }, this);
            (d === null || d === "") && o.push(u);
          }
          return o;
        },
        missing_some: function(o, i) {
          var c = t.apply({ missing: i }, this);
          return i.length - c.length >= o ? [] : c;
        }
      };
      return t.is_logic = function(o) {
        return typeof o == "object" && // An object
        o !== null && // but not null
        !Array.isArray(o) && // and not an array
        Object.keys(o).length === 1;
      }, t.truthy = function(o) {
        return Array.isArray(o) && o.length === 0 ? !1 : !!o;
      }, t.get_operator = function(o) {
        return Object.keys(o)[0];
      }, t.get_values = function(o) {
        return o[t.get_operator(o)];
      }, t.apply = function(o, i) {
        if (Array.isArray(o))
          return o.map(function(b) {
            return t.apply(b, i);
          });
        if (!t.is_logic(o))
          return o;
        var c = t.get_operator(o), u = o[c], d, h, g, m, S;
        if (Array.isArray(u) || (u = [u]), c === "if" || c == "?:") {
          for (d = 0; d < u.length - 1; d += 2)
            if (t.truthy(t.apply(u[d], i)))
              return t.apply(u[d + 1], i);
          return u.length === d + 1 ? t.apply(u[d], i) : null;
        } else if (c === "and") {
          for (d = 0; d < u.length; d += 1)
            if (h = t.apply(u[d], i), !t.truthy(h))
              return h;
          return h;
        } else if (c === "or") {
          for (d = 0; d < u.length; d += 1)
            if (h = t.apply(u[d], i), t.truthy(h))
              return h;
          return h;
        } else {
          if (c === "filter")
            return m = t.apply(u[0], i), g = u[1], Array.isArray(m) ? m.filter(function(b) {
              return t.truthy(t.apply(g, b));
            }) : [];
          if (c === "map")
            return m = t.apply(u[0], i), g = u[1], Array.isArray(m) ? m.map(function(b) {
              return t.apply(g, b);
            }) : [];
          if (c === "reduce")
            return m = t.apply(u[0], i), g = u[1], S = typeof u[2] < "u" ? t.apply(u[2], i) : null, Array.isArray(m) ? m.reduce(
              function(b, T) {
                return t.apply(
                  g,
                  { current: T, accumulator: b }
                );
              },
              S
            ) : S;
          if (c === "all") {
            if (m = t.apply(u[0], i), g = u[1], !Array.isArray(m) || !m.length)
              return !1;
            for (d = 0; d < m.length; d += 1)
              if (!t.truthy(t.apply(g, m[d])))
                return !1;
            return !0;
          } else if (c === "none") {
            if (m = t.apply(u[0], i), g = u[1], !Array.isArray(m) || !m.length)
              return !0;
            for (d = 0; d < m.length; d += 1)
              if (t.truthy(t.apply(g, m[d])))
                return !1;
            return !0;
          } else if (c === "some") {
            if (m = t.apply(u[0], i), g = u[1], !Array.isArray(m) || !m.length)
              return !1;
            for (d = 0; d < m.length; d += 1)
              if (t.truthy(t.apply(g, m[d])))
                return !0;
            return !1;
          }
        }
        if (u = u.map(function(b) {
          return t.apply(b, i);
        }), s.hasOwnProperty(c) && typeof s[c] == "function")
          return s[c].apply(i, u);
        if (c.indexOf(".") > 0) {
          var v = String(c).split("."), M = s;
          for (d = 0; d < v.length; d++) {
            if (!M.hasOwnProperty(v[d]))
              throw new Error("Unrecognized operation " + c + " (failed at " + v.slice(0, d + 1).join(".") + ")");
            M = M[v[d]];
          }
          return M.apply(i, u);
        }
        throw new Error("Unrecognized operation " + c);
      }, t.uses_data = function(o) {
        var i = [];
        if (t.is_logic(o)) {
          var c = t.get_operator(o), u = o[c];
          Array.isArray(u) || (u = [u]), c === "var" ? i.push(u[0]) : u.forEach(function(d) {
            i.push.apply(i, t.uses_data(d));
          });
        }
        return n(i);
      }, t.add_operation = function(o, i) {
        s[o] = i;
      }, t.rm_operation = function(o) {
        delete s[o];
      }, t.rule_like = function(o, i) {
        if (i === o || i === "@")
          return !0;
        if (i === "number")
          return typeof o == "number";
        if (i === "string")
          return typeof o == "string";
        if (i === "array")
          return Array.isArray(o) && !t.is_logic(o);
        if (t.is_logic(i)) {
          if (t.is_logic(o)) {
            var c = t.get_operator(i), u = t.get_operator(o);
            if (c === "@" || c === u)
              return t.rule_like(
                t.get_values(o, !1),
                t.get_values(i, !1)
              );
          }
          return !1;
        }
        if (Array.isArray(i))
          if (Array.isArray(o)) {
            if (i.length !== o.length)
              return !1;
            for (var d = 0; d < i.length; d += 1)
              if (!t.rule_like(o[d], i[d]))
                return !1;
            return !0;
          } else
            return !1;
        return !1;
      }, t;
    });
  }(E)), E.exports;
}
var f = fr();
const hr = {
  "en-US": C,
  "de-DE": lr
};
f.add_operation("object", function(...e) {
  return e.reduce((r, [n, t]) => (r[n] = t, r), {});
});
f.add_operation("Object.fromEntries", function(...e) {
  return Object.fromEntries(e);
});
f.add_operation("Object.entries", function(e) {
  return Object.entries(e);
});
f.add_operation("Object.values", function(e) {
  return Object.values(e);
});
f.add_operation("Object.keys", function(e) {
  return Object.keys(e);
});
f.add_operation("reverse", function(e) {
  return [...e].reverse();
});
f.add_operation("Array.reverse", function(e) {
  return [...e].reverse();
});
f.add_operation("Array.extendEach", function(e, r) {
  return e.map((n) => ({ ...n, ...r }));
});
f.add_operation("jsonstringify", function(e) {
  return JSON.stringify(e);
});
f.add_operation("JSON.stringify", function(e) {
  return JSON.stringify(e);
});
f.add_operation("jsonparse", function(e) {
  return JSON.parse(e);
});
f.add_operation("JSON.parse", function(e) {
  return JSON.parse(e);
});
f.add_operation("join", function(e, ...r) {
  return r.join(e);
});
f.add_operation("Array.join", function(e, r) {
  return e.join(r);
});
f.add_operation("get", function(e, r) {
  return U(e, r);
});
f.add_operation("lodash.get", function(e, r) {
  return U(e, r);
});
f.add_operation("Date.now", function() {
  return Date.now();
});
f.add_operation("Date.format", function(e, r, n) {
  const t = hr[n] ?? C;
  try {
    return fn(e, r, { locale: t });
  } catch {
    return "";
  }
});
f.add_operation("String.replaceAllBasedOnMap", function(e, r, n) {
  let t = e;
  return Object.keys(r).forEach((s) => {
    const o = f.apply(r[s], n);
    t = t.replaceAll(s, o);
  }), t;
});
f.add_operation("Number.format", function(e, r, n) {
  const t = r ?? "en-US";
  return new Intl.NumberFormat(t, {
    maximumFractionDigits: n,
    minimumFractionDigits: n
  }).format(e);
});
const xr = (e, r) => f.apply(e, r);
var G;
(function(e) {
  e.TABLE_DATA_CHANGE = "TABLE_DATA_CHANGE", e.SCHEDULE = "SCHEDULE";
})(G || (G = {}));
var B;
(function(e) {
  e.createType = "createType", e.updateType = "updateType", e.deleteType = "deleteType", e.openAICompletion = "openAICompletion", e.openAIEmbeddings = "openAIEmbeddings", e.type = "type", e.listType = "listType", e.listTypeByParent = "listTypeByParent", e.batchCreateType = "batchCreateType", e.notifyWebSocket = "notifyWebSocket", e.elevenLabsTTS = "elevenLabsTTS", e.logic = "logic", e.createFont = "createFont", e.htmlToPdf = "htmlToPdf", e.openAIImageGeneration = "openAIImageGeneration", e.batchGetType = "batchGetType", e.googleSearch = "googleSearch", e.linkScraper = "linkScraper", e.httpRequest = "httpRequest", e.extractImageMetadata = "extractImageMetadata", e.cloudFunction = "cloudFunction", e.genericAI = "genericAI";
})(B || (B = {}));
export {
  B as S,
  G as T,
  xr as a,
  Mr as g
};
